import { createSelector } from 'reselect';
import get from 'transmute/get';
import { getThreadListMembersMap } from '../../thread-list-member/selectors/getThreadListMembersMap';
import { getFocusedViewMemberThreadId } from './getFocusedViewMemberThreadId';
export const getFocusedViewMember = createSelector([getFocusedViewMemberThreadId, getThreadListMembersMap],
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
(threadId, threadListMembersMap) => get(threadId, threadListMembersMap));